module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/PatriotGames.d937e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/PatriotGames.jpg
// module id = WSHh
// module chunks = 0